<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <section class="qi-content">
        <header>
          <h1> Minhas Pré-Matrículas  </h1>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <Abas />
      </section>
    </div>
  </div>
</template>

<script>
import Abas from "../components/Registration/Tabs"
	export default {
		name: 'Registration',
		components:{
			Abas,
		}
	}
</script>
